import { EMAIL_SCREEN } from '../EmailVerification/types'
import {
  ButtonTracking,
  ScreenTracking,
  SCREEN_ASSET_ID
} from '../../domain/amplitude'

type VerificationType = 'phoneNumber'

export const PHONE_VERIFICATION: VerificationType = 'phoneNumber'

export type PhoneVerificationData = {
  type: VerificationType
  code: string
}

export type PhoneVerificationProps = {
  phone: string | null
  isError?: boolean
  isInvalid?: boolean
  isLoading?: boolean
  phoneNewCode: () => Promise<void>
  onSubmitCode: (data: PhoneVerificationData) => Promise<void>
}

export type PhoneVerificationFormState = {
  primaryPhone: string
  validationErrors: Record<string, string | void>
}

export type PhoneContainerPhoneState = Pick<
  PhoneVerificationFormState,
  'primaryPhone'
>

export type PhoneVerificationFormProps = {
  onSumbit: (string: PhoneContainerPhoneState) => void
  isError?: boolean
  isLoading?: boolean
}

export const SCREEN_SMS = 'application_SMS'
export const SCREEN_CODE = 'application_SMS_code'

export const ScreenOpenedEvent: ScreenTracking = {
  heading: 'What’s your mobile number',
  screen: SCREEN_SMS,
  asset_id: SCREEN_ASSET_ID,
  from_screen: EMAIL_SCREEN
}

export const ScreenSmsCodeEvent: ScreenTracking = {
  heading: 'Enter the verification code sent to phone',
  screen: SCREEN_CODE,
  asset_id: SCREEN_ASSET_ID,
  from_screen: SCREEN_SMS
}

export const InitiatePhoneButtonEvent: ButtonTracking = {
  asset_id: 'nextButton',
  asset_text: 'NEXT',
  screen: SCREEN_SMS
}

export const SubmitCodeButtonEvent: ButtonTracking = {
  asset_id: 'nextButton',
  asset_text: 'NEXT',
  screen: SCREEN_CODE
}

export const NewCodeButtonEvent: ButtonTracking = {
  asset_id: 'newCodeButton',
  asset_text: 'Get a new code',
  screen: SCREEN_CODE
}
